/**
 * The script launches the application by bootstrapping its root module.
 * Because the application runs directly in the browser, "main.ts" imports the "platformBrowserDynamic" function.
 * It initializes the platform and then uses it to bootstrap "AppModule".
 */

import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";

if (process.env.ENV === "production") {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule).catch(error => console.log(error));
